import axios from "axios";
import { BASE_URL } from "../utils/constants";

// Kept in memory, not localStorage, so it can't be read by an XSS payload.
let csrfToken: string | null = null;

export const fetchCsrfToken = async (): Promise<string> => {
  try {
    const response = await axios.get(`${BASE_URL}/csrf-token`, {
      withCredentials: true, // Required for cookie-based CSRF
    });

    const token = response.data?.csrfToken;

    if (!token) {
      throw new Error("No CSRF token received from server");
    }

    csrfToken = token;
    return token;
  } catch (error) {
    console.error("Failed to fetch CSRF token:", error);
    throw error;
  }
};

export const getCsrfToken = (): string | null => {
  return csrfToken;
};

export const setCsrfToken = (token: string): void => {
  csrfToken = token;
};

export const clearCsrfToken = (): void => {
  csrfToken = null;
};

export const hasCsrfToken = (): boolean => {
  return csrfToken !== null && csrfToken !== "";
};
